import React, { useState } from 'react'
import AuthMethodType from '../../constants/authMethods'
import authenticationService from '../../services/authenticationService'
import { useTranslation } from 'react-i18next'
import { CircleSpinner } from 'shared'
interface EParakstsLoginBlockProps {
	onError?(error: Error): void
}
function EParakstsContentBlock({
	onError = () => {},
}: EParakstsLoginBlockProps) {
	const [loading, setLoading] = useState<boolean>(false)

	async function eParakstsAuth() {
		setLoading(true)
		try {
			const redirectUrl =
				await authenticationService.eParakstsRedirectLinkGet()
			window.location.href = redirectUrl
		} catch (error: any) {
			onError(error)
			setLoading(false)
		}
	}

	React.useEffect(
		() => {
			eParakstsAuth()
		},
		// eslint-disable-next-line
		[],
	)

	const { t } = useTranslation()
	// @ts-ignore
	// prettier-ignore
	const buttonRounded = (
		<div
			key={AuthMethodType.eparaksts}
			className="eparaksts pb-4">
			<b>{t('Login')}</b>
		</div>
	)

	return (
		<React.Fragment>
			{loading ? (
				<div className="login-container m-2 d-flex flex-column justify-content-center">
					<CircleSpinner />
				</div>
			) : (
				<div
					onClick={() => eParakstsAuth()}
					className="login-container m-2 d-flex flex-column justify-content-between align-items-center pointer">
					<div className="btn authButton eparaksts"></div>
					<div>{buttonRounded}</div>
				</div>
			)}
		</React.Fragment>
	)
}
export default EParakstsContentBlock
